import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d51c0a4e")

_pushScopeId("data-v-d51c0a4e")
const _hoisted_1 = {
  style: {"justify-content":"space-between","margin-bottom":"20px"},
  class: "tree_label"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "皮肤页签", -1)
const _hoisted_3 = {
  key: 0,
  class: "tree-box tree_padding"
}
const _hoisted_4 = { class: "tree-container" }
const _hoisted_5 = { style: {"height":"550px"} }
const _hoisted_6 = { class: "custom-tree-node tree_label" }
const _hoisted_7 = { class: "tree_icon" }
const _hoisted_8 = { style: {"width":"600px","display":"flex","flex-direction":"column","justify-content":"space-between"} }
const _hoisted_9 = {
  class: "tree_label",
  style: {"justify-content":"space-between","margin-bottom":"20px"}
}
const _hoisted_10 = {
  key: 0,
  style: {"margin-left":"20px","font-weight":"bold"}
}
const _hoisted_11 = {
  key: 1,
  style: {"margin-left":"20px","font-weight":"bold"}
}
const _hoisted_12 = { style: {"height":"450px"} }
const _hoisted_13 = { class: "tree_icon" }
const _hoisted_14 = { style: {"margin-left":"20px"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("导出数据")
const _hoisted_19 = { style: {"color":"#70c1f1"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_aside, {
            ref: "sidebar",
            width: "200px;",
            style: {"width":"200px"},
            class: "sidebar"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode("span", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.creatTag && _ctx.creatTag(...args))),
                  style: {"font-size":"12px","color":"#fff"}
                }, "添加标签")
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tag_list, (item) => {
                return (_openBlock(), _createBlock("div", {
                  style: {"justify-content":"space-between"},
                  key: item,
                  class: "item tree_label"
                }, [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: item.tab_name,
                    placement: "top"
                  }, {
                    default: _withId(() => [
                      _createVNode("div", {
                        style: {"width":"80px","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
                        class: _ctx.tag_id == item.id ? 'orange_show' : 'skin-name'
                      }, _toDisplayString(item.tab_name), 3)
                    ]),
                    _: 2
                  }, 1032, ["content"]),
                  _createVNode("div", null, [
                    _createVNode("span", {
                      style: {"margin-right":"5px"},
                      class: [
                _ctx.tag_id == item.id && _ctx.text_cont == '展示' ? 'blue_show' : 'edit'
              , "edit"],
                      onClick: ($event: any) => (_ctx.treeShowBtn(item))
                    }, "展示", 10, ["onClick"]),
                    _createVNode("span", {
                      class: [
                _ctx.tag_id == item.id && _ctx.text_cont == '编辑' ? 'blue_show' : 'edit'
              , "edit"],
                      onClick: ($event: any) => (_ctx.treeBtn(item))
                    }, "编辑", 10, ["onClick"])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 512),
          _createVNode(_component_el_container, null, {
            default: _withId(() => [
              _createVNode(_component_el_container, null, {
                default: _withId(() => [
                  _createVNode(_component_el_main, { style: {"padding":"20px","margin-left":"200px","background":"#fff","box-sizing":"border-box"} }, {
                    default: _withId(() => [
                      _createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          (_ctx.tree_show)
                            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_3, [
                                _createVNode("div", _hoisted_4, [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.filter_input,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter_input = $event)),
                                    placeholder: "搜索",
                                    "prefix-icon": "el-icon-search",
                                    size: "mini",
                                    onInput: _ctx.handleFilter
                                  }, null, 8, ["modelValue", "onInput"]),
                                  _createVNode("div", _hoisted_5, [
                                    _createVNode(_component_el_scrollbar, { "max-height": "550px" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_tree, {
                                          ref: "tree",
                                          style: {"min-width":"600px","background":"#f5f6fa"},
                                          data: _ctx.dataSource,
                                          "filter-node-method": _ctx.filterNode,
                                          "show-checkbox": "",
                                          "node-key": "id",
                                          "expand-on-click-node": false,
                                          onCheckChange: _ctx.handleCheckChange
                                        }, {
                                          default: _withId(({ node, data }) => [
                                            _createVNode("span", _hoisted_6, [
                                              _createVNode("span", _hoisted_7, [
                                                _createVNode("img", {
                                                  src: data.icon
                                                }, null, 8, ["src"])
                                              ]),
                                              _createVNode("span", null, _toDisplayString(node.label), 1)
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["data", "filter-node-method", "onCheckChange"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _createVNode("div", _hoisted_8, [
                                  _createVNode("div", _hoisted_9, [
                                    (_ctx.checkedNodes.length == 0)
                                      ? (_openBlock(), _createBlock("div", _hoisted_10, " 添加皮肤类别 "))
                                      : (_openBlock(), _createBlock("div", _hoisted_11, " 已选择皮肤" + _toDisplayString(_ctx.checkedNodes.length), 1)),
                                    _createVNode("div", null, [
                                      _createVNode("span", {
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearBtn && _ctx.clearBtn(...args))),
                                        style: {"font-size":"22px"},
                                        class: "el-icon-close close-icon"
                                      })
                                    ])
                                  ]),
                                  _createVNode("div", _hoisted_12, [
                                    _createVNode(_component_el_scrollbar, { "max-height": "450px" }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkedNodes, (item) => {
                                          return (_openBlock(), _createBlock("div", {
                                            style: {"margin-left":"20px","margin-bottom":"10px","justify-content":"space-between"},
                                            class: "tree_label",
                                            key: item
                                          }, [
                                            _createVNode("div", null, [
                                              _createVNode("span", _hoisted_13, [
                                                _createVNode("img", {
                                                  src: item.icon
                                                }, null, 8, ["src"])
                                              ]),
                                              _createVNode("span", null, _toDisplayString(item.label), 1)
                                            ]),
                                            _createVNode("span", {
                                              class: "el-icon-close close-icon",
                                              style: {"margin-right":"10px"},
                                              onClick: ($event: any) => (_ctx.handleRemove(item))
                                            }, null, 8, ["onClick"])
                                          ]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createVNode("div", _hoisted_14, [
                                    _createVNode(_component_el_form, {
                                      inline: true,
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_form_item, { label: "时间范围" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: _ctx.valueTime,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.valueTime = $event)),
                                              type: "daterange",
                                              "range-separator": "To",
                                              "start-placeholder": "开始日期",
                                              "end-placeholder": "结束日期",
                                              onChange: _ctx.timeChange,
                                              "default-value": _ctx.timeDefaultShow
                                            }, null, 8, ["modelValue", "onChange", "default-value"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form, {
                                      inline: true,
                                      size: "mini"
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_form_item, { label: "标签名" }, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.tag_name,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.tag_name = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              size: "mini",
                                              type: "primary",
                                              onClick: _ctx.confirm
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_15
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_el_button, {
                                              size: "mini",
                                              type: "primary",
                                              onClick: _ctx.deleteBtn
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_16
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ], 512)), [
                                [_directive_loading, _ctx.box_loading]
                              ])
                            : (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode(_component_el_form, {
                                  inline: true,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, { label: "结论" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_select, {
                                          onChange: _ctx.conclusionChange,
                                          modelValue: _ctx.conclusion,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.conclusion = $event))
                                        }, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.conclusion_list, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item,
                                                label: item,
                                                value: item
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["onChange", "modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, { label: "" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.exportData()))
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_18
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_checkbox, {
                                          modelValue: _ctx.filter,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter = $event)),
                                          label: "过滤show1高于20帧的数据",
                                          class: "ms-3",
                                          onChange: _ctx.onFilterChange
                                        }, null, 8, ["modelValue", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _withDirectives(_createVNode(_component_el_table, {
                                  class: "my-table-hok",
                                  size: "mini",
                                  "header-cell-style": {
                    background: '#42484E',
                    color: '#fff',
                  },
                                  data: _ctx.skin_data_list,
                                  "span-method": _ctx.mergeCells
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_table_column, { label: "ID" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.id), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "英雄" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.hero_name), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "皮肤" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.skin_name), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "套装" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.suitname || '--'), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "性别" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(_ctx.genderOptions[scope.row.gender]), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "场景" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.scene), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      width: "170",
                                      label: "机型"
                                    }, {
                                      default: _withId((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textOutsideBrackets), 1),
                                        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.extractBracketContents(scope.row.model)
                          .textInsideBrackets), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "帧率" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.frame_rate), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "标准" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString("≥" + scope.row.data.baseline), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "动作" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.action), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      width: "210",
                                      label: "版本日期"
                                    }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.date), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "结论" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", {
                                          class: 
                          scope.row.data.risk == '达标'
                            ? 'com_risk_green'
                            : 'com_risk_red'
                        
                                        }, _toDisplayString(scope.row.data.risk), 3)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "avgFps" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", {
                                          class: 
                          scope.row.data.avg_fps_risk ? 'com_risk_red' : ''
                        
                                        }, _toDisplayString(scope.row.data.avg_fps), 3)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "miniFps" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.min_fps), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "帧率方差" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.var_fps), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "avgCpu" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.avg_cpu), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "avgGpu" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.gpu_usage), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "maxPss" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.max_pss), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "avgPss" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.avg_pss), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "maxVss" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.max_vss), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "avgVss" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, _toDisplayString(scope.row.data.avg_vss), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "链接" }, {
                                      default: _withId((scope) => [
                                        _createVNode("span", null, [
                                          _createVNode("a", {
                                            target: "_blank",
                                            style: {"cursor":"pointer","color":"#70c1f1"},
                                            href: scope.row.data.url
                                          }, "查看", 8, ["href"])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data", "span-method"]), [
                                  [_directive_loading, _ctx.out_loading]
                                ])
                              ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})